import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { BASE_URL, HOTEL_URL, ADMIN_URL, AIR_URL } from './constant/BaseApiUrl';

export default class PackageManagementService {
  getListGateway() {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/list-for-management`);
  }

  updateGatewayStatus(payload) {
    return axios.put(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/${payload.code}/status?status=${payload.status}`);
  }

  addEditGateway(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}`, payload);
  }

  deleteEGateway(payload) {
    return axios.delete(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/${payload.code}`);
  }

  getListDestination() {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS_ONLY_HOTEL}/list-for-management`);
  }

  updateDestinationStatus(payload) {
    return axios.put(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS_ONLY_HOTEL}/${payload.code}/status?status=${payload.status}`);
  }

  addEditDestinationStatus(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS_ONLY_HOTEL}`, payload);
  }

  deleteDestination(payload) {
    return axios.delete(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS_ONLY_HOTEL}/${payload.code}`);
  }

  getListInstaquoteRule() {
    return axios.get(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}`);
  }

  getDetailInstaquoteRule(sk) {
    return axios.get(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}/${sk}`);
  }

  addInstaquoteRule(payload) {
    return axios.post(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}`, payload);
  }

  updateInstaquoteRuleStatus(sk, status) {
    return axios.put(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}/${sk}/status?status=${status}`);
  }

  deleteInstaquoteRuleStatus(sk) {
    return axios.delete(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}/${sk}`);
  }

  getOverlapDepature(params) {
    return axios.get(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}/get-overlap-departure`, { params });
  }

  getPricingQuote(id, body) {
    return axios.post(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/${id}/pricing`, body);
  }

  postSearchAdditional(body) {
    return axios.post(`${AIR_URL}${ApiKey.SEARCH_ADDITIONAL}`, body);
  }

  getArdTaxSearchAdditional(gateway: string, destination: string, duration: number) {
    return axios.get(`${ADMIN_URL}${ApiKey.FLIGHT_RULE}/ard-tax?gateway=${gateway}&destination=${destination}&duration=${duration}`);
  }

  getHcmsPromotion(id, body) {
    return axios.post(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/${id}/hcms-promotion`, body);
  }

  getListDestinationGroup() {
    return axios.get(`${HOTEL_URL}${ApiKey.DESTINATION_GROUP}`);
  }

  updateDestinationGroupStatus(sk, status) {
    return axios.post(`${HOTEL_URL}${ApiKey.DESTINATION_GROUP}/${sk}/${status}`);
  }

  deleteDestinationGroup(sk) {
    return axios.delete(`${HOTEL_URL}${ApiKey.DESTINATION_GROUP}/${sk}`);
  }

  updateDestination(payload) {
    return axios.put(`${HOTEL_URL}${ApiKey.GET_DESTINATIONS_ONLY_HOTEL}`, payload);
  }

  getListGatewayDuration() {
    return axios.get(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}`);
  }

  addGatewayDuration(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}`, payload);
  }

  updateGatewayDuration(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}`, payload);
  }

  deleteGatewayDuration(id) {
    return axios.delete(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}/${id}`);
  }

  updateStatusDuration(id, status) {
    return axios.put(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}/${id}?sts=${status}`);
  }

  getUrlPreviewFlightRule() {
    return `${ADMIN_URL}${ApiKey.FLIGHT_RULE}/${ApiKey.PREVIEW_FILE}`;
  }

  getUrlUploadFileGateway() {
    return `${HOTEL_URL}${ApiKey.GET_GATEWAYS}/${ApiKey.PREVIEW_FILE}`;
  }

  getUrlPreviewDestination() {
    return `${HOTEL_URL}${ApiKey.DESTINATIONS}/${ApiKey.PREVIEW_FILE}`;
  }

  importFileFlightRule(payload) {
    return axios.post(`${ADMIN_URL}${ApiKey.FLIGHT_RULE}/${ApiKey.IMPORT_FILE}`, payload);
  }

  importFileGateway(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/${ApiKey.IMPORT_FILE}`, payload);
  }

  importFileDestination(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.DESTINATIONS}/${ApiKey.IMPORT_FILE}`, payload);
  }

  getVersionRevert(type) {
    return axios.get(`${ADMIN_URL}${ApiKey.ADMINISTRATION}/file?fileType=${type}`);
  }

  getPreviewByFileName(fileName) {
    return axios.post(`${ADMIN_URL}${ApiKey.FLIGHT_RULE}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertVersion(fileName) {
    return axios.post(`${ADMIN_URL}${ApiKey.FLIGHT_RULE}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  getSeasonalRules() {
    return axios.get(`${ADMIN_URL}season/SEASON_ONLY`);
  }

  editSeasonalRules(payload) {
    return axios.post(`${ADMIN_URL}season`, payload);
  }

  getDetailSeasonalByType(type) {
    return axios.get(`${ADMIN_URL}season/type/${type}`);
  }

  getPreviewDestinationByFileName(fileName) {
    return axios.post(`${HOTEL_URL}${ApiKey.DESTINATIONS}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertVersionDestination(fileName) {
    return axios.post(`${HOTEL_URL}${ApiKey.DESTINATIONS}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  getPreviewGatewayByFileName(fileName) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertVersionGateway(fileName) {
    return axios.post(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  getUrlUploadGatewayDuration() {
    return `${HOTEL_URL}${ApiKey.GATEWAY_DURATION}/${ApiKey.PREVIEW_FILE}`;
  }

  importGatewayDuration(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}/${ApiKey.IMPORT_FILE}`, payload);
  }

  getPreviewGatewayDuration(fileName) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertGatewayDuration(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATEWAY_DURATION}/${ApiKey.REVERT_FILE}`, payload);
  }

  updateCostRuleStatus(sk, status) {
    return axios.put(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}/${sk}/cost-status?cost-status=${status}`);
  }

  updateRuleConnectorStatus(sk: string, connectorStatus: boolean) {
    return axios.put(`${ADMIN_URL}${ApiKey.RULE_MANAGEMENT}/${sk}/connector-status?connector-status=${connectorStatus}`);
  }

  getQuoteAdjusmentInfo(id, option) {
    return axios.get(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/cost-worksheet-calculation/${id}/${option}`);
  }

  saveQuoteAdjusmentInfo(id, option, payload) {
    return axios.put(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/cost-worksheet-calculation/${id}/${option}`, payload);
  }

  deleteQuoteAdjusmentInfo(id, option) {
    return axios.delete(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/cost-worksheet-calculation/${id}/${option}`);
  }

  getPricingTour(id: string, payload: any) {
    return axios.post(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/${id}/tour-pricing`, payload);
  }

  getCheckingQuoteIds(ids: string) {
    return axios.get(`${BASE_URL}quotes/check-existed?quote-ids=${ids}`);
  }
}
